export default 'aggregationConfigs'
